document.addEventListener("click", function (evt) {
  const target = evt.target
  if (!target.matches(".search-type-switch")) return
  const input = document.getElementById("page-type-input")
  if (target.ariaChecked) {
    // clicking on active filter removes it
    input.value = "article,page,product"
    target.ariaChecked = false
  } else {
    // toggle filter on
    const selected = document.querySelector(
      '.search-type-switch[aria-checked="true"]',
    )
    if (selected) selected.ariaChecked = false
    input.value = target.dataset.types
    target.ariaChecked = true
  }
  // trigger the collection reload
  input.dispatchEvent(new Event("input", { bubbles: true }))
})
